const GetAllTeamsInTerm_query = `
  query($termId: Int!) {
    getAllTeamsInTerm(termId: $termId) {
      teamTermId
      termId{
        termId
        termUuid
      } 
      teamId{
        teamId
        teamUuid
        name
        desc
      }
      goal    
      createDate
      createBy
      updateDate
      updateBy
    }
  }
`;

const GetAllTeamsInTermByRole_query = `
  query($termId: Int!, $isTenantAdmin: Boolean, $email: String!) {
    getAllTeamsInTermByRole(termId: $termId, isTenantAdmin: $isTenantAdmin, email: $email) {
      teamTermId
      termId{
        termId
        termUuid
      } 
      teamId{
        teamId
        teamUuid
        name
        desc
      }
      goal    
      createDate
      createBy
      updateDate
      updateBy
    }
  }
`;

const GetTermTeams_query = `
  query($termUuid: String!) {
    getTermTeams(termUuid: $termUuid) {
      teamTermId
      termId{
        termId
        termUuid
        name
      } 
      teamId{
        teamId
        teamUuid
        name
      }
      goal    
      createDate
      createBy
      updateDate
      updateBy
    }
  }
`;

const CreateTeamTerm_mutate = `
    mutation createTeamTerm(
      $termId: Int!
      $teamId: Int! 
      $goal: String    
      ) {
      createTeamTerm(
        termId: $termId,
        teamId: $teamId,
        goal: $goal,
         ) {
        teamTerm
        {
          teamTermId
          termId
          {
            termId
          }
          teamId{
            teamId
          }          
          goal
          createDate
          updateDate
                
        }
      }
    }
`;

const DeleteTeamTerm_mutate = `
    mutation delete_team_term($teamTermId: Int!) {
      deleteTeamTerm(teamTermId: $teamTermId) {
        response
      }
    }
`;

const NoOfTeamsInTerm_query = `
query($termId: Int!) {
  noOfTeamTerm(termId: $termId)
}
`;

const GetTeamAllTerms = `query($teamUuid: String!) {
    getTeamAllTerms(teamUuid: $teamUuid) {
      teamTermId
      termId{
        termUuid
        name
        startDate
        endDate
        current
      }
      teamId{
        name
      }
      goal
      noOfWeeks
      note
      noOfResources
    }
  }
`;

const GetTeamTermData_query = `
  query( $teamUuid: String! , $termUuid: String!)
  {
    getTeamTermData(teamUuid:$teamUuid, termUuid:$termUuid)
    {
      teamTermId
      termId{
        termUuid
        name
        startDate
        endDate
      }
      teamId{
        name
      }
      goal
      noOfWeeks
    }
  }
`;

const EditTeamTerm_mutate = `
  mutation editTeamTerm( 
    $teamTermId:Int!     
    $goal: String!            
    ) {
    editTeamTerm(
      teamTermId: $teamTermId,        
      goal: $goal,     
      ) {
      teamTerm
      {
        teamTermId
        teamId{
          teamId
          name
        }
        termId
        {
          termId
        }            
        goal
        createDate
        updateDate
      }
    }
  }
`;

const EditTeamTermNotes = `mutation editTeamTermNotes($teamTermId:Int!, $notes: String!){
  editTeamTermNotes(teamTermId: $teamTermId, notes: $notes){
    teamTerm{
      teamTermId
      note
    }
  }
}`;

const GetTeamTermDataById = `query($teamTermId: Int!){
  getTeamTermDataById(teamTermId:$teamTermId){
    termId{
      name
    }
    teamId{
      name
    }
    note
  }
}`;

const GetTeamsTermMemberByUser_query = `
  query($email: String!, $termId: Int!) {
    getTeamsTermMemberByUser(email: $email, termId: $termId) {
      teamTermMemberId
      roleId
      {
        roleId
        roleName
      }
      teamTermId
      {
        teamTermId
        termId{
          termId
          termUuid
          name
        }

        teamId{
          teamId
          teamUuid
          name
        }

      goal    
      createDate
      createBy
      updateDate
      updateBy
      }
      note
      noteUpdateDate
      noteUpdateBy
    }
  }
`;
const GetUserAllTeamsInTerm_query = `
  query($email: String!, $termId: Int!) {
    getUserAllTeamsInTerm(email: $email, termId: $termId) {
      teamTermId
      termId{
        termId
        termUuid
      } 
      teamId{
        teamId
        teamUuid
        name
      }
      goal    
      createDate
      createBy
      updateDate
      updateBy
    }
  }
`;

module.exports = {
  GET_ALL_TEAMS_IN_TERM_QUERY: GetAllTeamsInTerm_query,
  GET_ALL_TEAMS_IN_TERM_BY_ROLE_QUERY: GetAllTeamsInTermByRole_query,
  GET_TERM_TEAMS_QUERY: GetTermTeams_query,
  CREATE_TEAM_TERM_MUTATION: CreateTeamTerm_mutate,
  DELETE_TEAM_TERM_MUTATION: DeleteTeamTerm_mutate,
  NO_OF_TEAMS_QUERY: NoOfTeamsInTerm_query,
  GET_TEAM_ALL_TERMS: GetTeamAllTerms,
  GET_TEAM_DATA_BY_UUID: GetTeamTermData_query,
  EDIT_TEAM_TERM: EditTeamTerm_mutate,
  EDIT_TEAM_TERM_NOTES: EditTeamTermNotes,
  GET_TEAM_TERM_BY_ID: GetTeamTermDataById,
  GET_USER_ALL_TEAMS_IN_TERM_QUERY: GetUserAllTeamsInTerm_query,
  GET_TEAMS_TERM_MEMBER_BY_USER_QUERY: GetTeamsTermMemberByUser_query,
};
